export enum CmpConfigPublisherCustomPurposeTranslationField {
    NAME = "name",
    DESCRIPTION = "description",
}
